export enum JudgmentActionsEnum {
  ADD_JUDGMENT = 'Привлечение к ответственности',
  ANNULMENT_AKT = 'Оспаривание актов и/или решений КНО',
  ANNULMENT_JUDGMENT = 'Пересмотр судебного решения',
}
